export class Price {
  static addVAT (price) {
    // return Math.ceil((price * 1.2 / 100)).toFixed(2)
    return (price / 100).toFixed(2)
  }
}
